import { borderColor, borderRadius, borderStyle, borderWidth } from "polished"
import { IconAtom } from "../atoms/iconAtom"
import { TextAreaForm } from "../atoms/input"
import { StandardComp } from "../atoms/standardComp"
import { TextAtom } from "../atoms/TextAtom"
import { TitleAtom } from "../atoms/titleAtom"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { StandardButton } from "../atoms/buttons"
import { useContext, useEffect, useState } from "react"
import { PageContext } from "../App"
import { getAPI, postAPI } from "../api/api"
import { set } from "date-fns"
import { Spinner } from "../atoms/spinner"

export const LinkedinComp = () => {
    const { id_lead } = useContext(PageContext).sidebar
    const [status, setStatus] = useState(false)
    const [messages, setMessages] = useState([])
    const [activeMessage, setActiveMessage] = useState("")
    const [recommendations, setRecommendations] = useState([])
    const [loader, setLoader] = useState(false)
    const loadLinkedinMessages = async () => {
        const query = `api/linkedin/messages?id_lead=${id_lead}`
        const messages = await getAPI(query)
        setMessages(messages.data)
    }

    const loadRecommendations = async () => {
        const query = `api/linkedin/recommendations?id_lead=${id_lead}`
        const recommendations_now = await postAPI(query)
        console.log("recommendations", recommendations_now.data)
        setRecommendations(recommendations_now.data)
    }
    const loadLinkedinStatus = async () => {

        //fetch linkedin data
        const query = `api/linkedin/status?id_lead=${id_lead}`
        const status = await getAPI(query)
        if (status.data.connected === 3) {
            setStatus(true)
        }
    }
    const handleRecommend = (index) => {
        setActiveMessage(recommendations[index].message)
        setRecommendations([...recommendations.slice(0, index), ...recommendations.slice(index + 1)])
    }

    const handleSendMessage = async () => {
        //send message to backend
        const query = `api/linkedin/send-message`
        const body = {
            id_lead,
            message: activeMessage
        }
        setLoader(true)
        await postAPI(query, body)
        setLoader(false)
        setActiveMessage("")
        setRecommendations([])
        loadLinkedinMessages()
    }

    useEffect(() => {
        loadLinkedinStatus()
        loadLinkedinMessages()
        loadRecommendations()
    }, [])
    return (
        status &&
        <StandardComp style={{ gap: "1rem", display: "flex", flexDirection: "column", margin: 0 }}>
            <HeaderLinkedinAI />
            {messages.length > 0 && <LastMessages messages={messages} />}
            {recommendations.length > 0 && <Recommendations recommend={handleRecommend} recommendations={recommendations} />}
            <Message sendMessage={handleSendMessage} isLoading={loader} lead={{ name: "" }} message={activeMessage} />
        </StandardComp>
    )
}

const HeaderLinkedinAI = () => {
    return (
        <HorizontalLayout style={{ gap: "0.5rem" }}>
            <IconAtom
                style={{ display: 'flex' }}
                iconSize={24}
                color={"var(--grey-700)"}
                icon2={"linkedin"}
            />
            <TextAtom style={{ fontSize: "1rem", fontWeight: "bold", color: "var(--grey-700)" }} title={"AI linkedin berichten"} />


        </HorizontalLayout>
    )
}

const LastMessages = ({ messages }) => {
    return (
        <VerticalLayout style={{ gap: "0.4rem" }}>
            <TextAtom style={{ fontSize: "0.8rem", fontWeight: "bold", color: "var(--grey-600)" }} title={"Laatste berichten"} />

            <CommuncationMessages
                messages={messages}
            />
        </VerticalLayout>
    )
}


const CommuncationMessages = ({ messages }) => {
    return (
        <VerticalLayout>
            {messages.map((message, index) => {
                return (
                    <CommunicationMessage message={message} />
                )
            })}
        </VerticalLayout>
    )
}

const CommunicationMessage = ({ message }) => {
    return (

        <StandardComp style={{ padding: "0.75rem" }}>
            <TextAtom

                title={message.title}
            />
        </StandardComp>
    )
}
const Message = ({ isLoading, lead, message, sendMessage }) => {
    return (
        <VerticalLayout style={{ gap: 0 }}>
            <MessageHeader
                lead={lead}
            />
            <MessageField message={message} />
            <SendField isLoading={isLoading} sendMessage={sendMessage} />
        </VerticalLayout>
    )
}


const MessageHeader = ({ lead }) => {
    return (
        <HorizontalLayout style={{ width: "unset", backgroundColor: "var(--grey-100)", padding: "0.5rem", paddingTop: "0.75rem", paddingBottom: "0.75rem", gap: "0.5rem", marginBottom: "-0.2rem", borderTopLeftRadius: "0.5rem", borderTopRightRadius: "0.5rem", borderColor: "var(--grey-300)", borderStyle: "solid", borderWidth: "1px" }}>
            <div className={"bullet-point"} style={{ backgroundColor: "var(--primary-600)" }}></div>
            <TextAtom
                style={{ fontSize: "0.8rem" }}
                title={`Vertsuur hier direct een bericht naar ${lead.name}`}
            />
        </HorizontalLayout>
    );
};

const MessageField = ({ message }) => {
    return (
        <TextAreaForm
            value={message}
            placeholder={"Druk op een van de aanbeveling om hier direct in toe voegen"}
            style={{ marginBottom: 0 }}
            textAreaStyle={{ borderRadius: 0 }}

        />
    );
};

const SendField = ({ isLoading, sendMessage }) => {
    return (
        <HorizontalLayout style={{ width: "unset", padding: "0.5rem", gap: "0.5rem", marginBottom: "-0.2rem", borderBottomLeftRadius: "0.5rem", borderBottomRightRadius: "0.5rem", borderColor: "var(--grey-300)", borderStyle: "solid", borderWidth: "1px", borderTopWidth: "0", marginTop: "-0.4rem" }}>
            {true && <TextAtom title="Een ogenblik geduld.." />}
            <StandardButton
                onClick={sendMessage}
                style={{ marginLeft: "auto", borderRadius: 11000 }}
                className={"send-button"}
                disabled={isLoading}
            >
                {true ? <Spinner color={"white"} size={16} isLoading={true} /> : "Verstuur bericht"}
            </StandardButton>

        </HorizontalLayout>
    );
};

const Recommendations = ({ recommendations, recommend }) => {
    return (
        <VerticalLayout style={{ gap: "0.4rem" }}>
            <TextAtom style={{ fontSize: "0.8rem", fontWeight: "bold", color: "var(--grey-600)" }} title={"Aanbevelingen"} />
            <VerticalLayout style={{ gap: "0.5rem" }}>
                {recommendations.map((recommendation, index) => {
                    return (
                        <Recommendation click={() => recommend(index)} data={recommendation} />
                    )
                })}
            </VerticalLayout>
        </VerticalLayout>
    )
}

const Recommendation = ({ data, click }) => {
    return (
        <StandardComp style={{ padding: "0.75rem" }} onClick={click}>
            <HorizontalLayout style={{ gap: "0.5rem", alignItems: "center" }}>
                <IconAtom color={"var(--primary-600)"} style={{ display: "flex" }} icon2={"Comment"} />
                <TextAtom style={{ fontWeight: "bold", fontSize: "0.8rem" }} title={data.message_goal} />
            </HorizontalLayout>
            <TextAtom title={data.message} />
        </StandardComp>
    )
}